const pages: { [key: string]: string } = {
  home: "Home",
  colors: "Colors",

  avatars: "Avatars",
  branding: "Branding",
  icons: "Icons",
  illustrations: "Illustrations",
  images: "Images",

  alerts: "Alerts",
  animations: "Animations",
  buttons: "Buttons",
  chips: "Chips",
  dialogs: "Dialogs",
  modals: "Modals",
  errors: "Errors",
  forms: "Forms",
  suspense: "Suspense",
  otherInteractions: "Other Interactions",

  containers: "Containers",
  dividers: "Dividers",
  otherLayout: "Other Layout",

  aside: "Aside",
  header: "Header",
  footer: "Footer",
  otherNavigation: "Other Navigation",

  settings: "Settings",
  typography: "Typography",

  cards: "Cards",
  charts: "Charts",
  metrics: "Metrics",
  tables: "Tables",

  notFound: "404 Error | Page Not Found",
  error: "Error",
};

const common = " | Crescent Applications React UI";

const pageTitle = (page: keyof typeof pages) => {
  return pages[page] + common;
};

export default pageTitle;
